"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysterySection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const wagmi_1 = require("wagmi");
const provider_user_1 = require("@dzambalaorg/provider-user");
const types_1 = require("@framework/types");
const constants_1 = require("@dzambalaorg/constants");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../types");
const data = [
    { text: "pages.mystery.contracts.title", link: "/mystery/contracts", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Collections, {}) },
    { text: "pages.mystery.boxes.title", link: "/mystery/boxes", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Inventory, {}) },
    { text: "pages.mystery.tokens.title", link: "/mystery/tokens", icon: (0, jsx_runtime_1.jsx)(icons_material_1.Storage, {}) },
];
const MysterySection = ({ service }) => {
    const { profile } = (0, provider_user_1.useUser)();
    const { chainId = 0 } = (0, wagmi_1.useAccount)();
    if (service === types_2.ServiceType.ADMIN && profile?.merchant?.ratePlan === types_1.RatePlanType.BRONZE) {
        return null;
    }
    if (process.env.NODE_ENV === constants_1.NodeEnv.production && !types_1.ChainLinkV2SupportedChains[chainId]) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.mechanics.mystery" }) }), children: data.map(({ text, icon, link }) => ((0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: link, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: icon }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: text }) })] }, text))) }) }));
};
exports.MysterySection = MysterySection;
//# sourceMappingURL=mystery.js.map